import React from "react";
import { BsTwitterX, BsInstagram, BsLinkedin } from "react-icons/bs";
import { PiCopyright } from "react-icons/pi";
import { TbGalaxy } from "react-icons/tb";
import { useLanguage } from "../Translations/LenguageContext";
import { HiTranslate } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";

const Footer = ({ NavigatePagesHome }) => {
    const { t, changeLanguage, language } = useLanguage()
    const navigate = useNavigate()
    const year = new Date().getFullYear();

    const handleLanguageChange = (event) => {
        changeLanguage(event.target.value);
    };

    const LegalNavigate = (page) => {
        navigate(`/${page}`)
    }

    return (
        <div className="footer_cont">
            <div className="end_footer">
                <div className="end_footer_item">
                    <p><PiCopyright /> {year} Erioon.</p>
                    <p>All rights reserved.</p>
                </div>
                <div className="end_footer_item">
                    <p onClick={() => { LegalNavigate("cookie-policy") }}>Cookies</p>
                    <p onClick={() => { LegalNavigate("terms-and-conditions") }}>Legal Notes</p>
                    <p onClick={() => { LegalNavigate("privacy-policy") }}>Privacy Policy</p>
                    <p onClick={() => { LegalNavigate("terms-and-conditions") }}>Terms & Conditions</p>
                </div>
                <div className="end_footer_item">
                    <div className="end_footer_socials">
                        <a href="https://www.linkedin.com/company/erioon" target="_blank" rel="noopener noreferrer">
                            <i><BsLinkedin /></i>
                        </a>
                          <a href="https://x.com/ErioonLabs" target="_blank" rel="noopener noreferrer">
                            <i><BsTwitterX /></i>
                        </a>
                        {/* <p><i><BsInstagram /></i></p> */}
                        {/* <p><i><BsTwitterX /></i></p> */}
                    </div>
                </div>
            </div>
            <p className="t0comp_mex">Erioon is a <a href="https://t0.erioon.com">Type Zero</a> company</p>
        </div>
    )
}

export default Footer